<template>
  <div>
    <div class="banner">
      <!-- 第一屏 -->
      <div style="width: 100%; height: 950px"></div>
      <div style="width: 100%; height: 100%">
        <div style="position: fixed; top: 0; left: 0; z-index: 99; width: 100%" ref="heads">
          <headers></headers>
        </div>

        <img
          style="width: 100%; position: absolute; top: 0; height: 950px"
          src="https://gcjy-images-cdn.ahsjxjy.com/ahzcj/prod/ahzcj-api/2026/03/19/ahzcj-api_1773882986497.jpg"
          alt="专业技术人员继续教育管理平台"
        />
        <div class="bgc">
          <div class="fsk">
            <div style="width: 1048px">
              <div
                class="flexCenter"
                style="
                  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
                  margin-bottom: 30px;
                  font-weight: 800;
                  font-size: 28px;
                  color: #ffffff;
                "
              >
                安徽职业与成人教育学习网
                <!-- <img
                  style="width: 665px; height: 49px"
                  src="../assets/indexImg/Group 1242@2x.png"
                  alt="专业技术人员继续教育管理平台"
                /> -->
              </div>
              <!-- <div class="txt1">加强应急管理/增强应急意识/提升应急能力</div> -->
              <div class="swInput flexCenter">
                <div style="display: flex">
                  <input class="searCh" v-model="className" placeholder="输入您感兴趣的班级名称" />
                  <div class="searBtn" @click="searClass">搜 索</div>
                </div>
              </div>
              <div class="listBox">
                <div class="zjBox">
                  <div style="display: flex">
                    <div style="display: flex; align-items: center">
                      <!-- <img src="../assets/indexImg/baoming.png" alt="专业技术人员继续教育管理平台" /> -->
                    </div>
                    <div style="color: #eb5b25; font-weight: bold; margin-left: 4px">报名选课</div>
                  </div>
                 <div style="min-height: 240px; display: flex; flex-wrap: wrap; margin-top: 10px" v-if="codeList.length > 0">
                    <div class="xwList" v-for="v in codeList" :key="v.ID" @click="handleCode(v.CODE_NO)">
                      {{ v.CODE_NAME }}
                      <!-- <span>{{ v.PUBLISHTIME }}</span> -->
                    </div>
                  </div>
                  <div style="min-height: 240px" v-else>
                    <div style="color: #ffffff; margin-top: 30px; text-align: center">暂无分类~</div>
                  </div>

                  <div class="flexCenter" style="width: 100%;margin-top: 20px;">
                    <div class="btnMore" @click="goCode">了解更多</div>
                  </div>
                </div>
                <div class="zjBox">
                  <div style="display: flex">
                    <div style="display: flex; align-items: center">
                      <img src="../assets/indexImg/zj.png" alt="专业技术人员继续教育管理平台" />
                    </div>
                    <div style="color: #1fd000; font-weight: bold; margin-left: 4px">通知公告</div>
                  </div>

                  <div style="min-height: 240px" v-if="tzggList.length > 0">
                    <div class="xwList1" v-for="item in tzggList" :key="item.ID" @click="goFg(item.ID, '1', index)">
                      <span class="xwText">{{ item.TITLE }}</span
                      ><span>{{ item.PUBLISHTIME }}</span>
                    </div>
                  </div>
                  <div style="min-height: 240px" v-else>
                    <div style="color: #ffffff; margin-top: 30px; text-align: center">暂无通告~</div>
                  </div>
                  <div class="flexCenter" style="width: 100%;margin-top: 20px;">
                    <div class="btnMore" @click="goFg('', '1')">了解更多</div>
                  </div>
                </div>
              </div>
              <!-- <div class="listBox2">
                <div class="fwBox" v-for="item in kstdCodeList" :key="item.id" @click="goKstd(item.CODE_NO)">
                  <div style="padding: 20px" class="borBox">
                    <div class="txt2">
                      <div><img src="../assets/indexImg/11.png" alt="专业技术人员继续教育管理平台" /></div>
                      <div style="margin-left: 8px; color: #fff">{{ item.CODE_NAME }}</div>
                    </div>
                    <div class="txt3">{{ item.CODE_DESC == null ? '暂无介绍' : item.CODE_DESC }}</div>
                  </div>
                  <div class="bor"></div>
                  <div class="txt4">立即进入</div>
                </div>
              </div> -->
              <!-- <div class="bottom11">
                <div class="text_1">
                  <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">ICP备案号: 陕ICP备2024047720号</a>
                </div>
                <div class="text_2">技术支持: 筋斗云学习网</div>

                <div class="text_3">
                  <img src="../assets/indexImg/icon11.png" alt="" style="margin-right: 5px" />
                  <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">陕公网安备61019602000477</a>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import headers from './component/head.vue';
import pcBottom from './component/bottom.vue';
import Baywindow from './component/Baywindow.vue';
import flotRight from '@/views/component/flotRight.vue';
import sztd from './component/sztd.vue';
import jxfw from './component/jxfw.vue';
import xyxs from './component/xyxs.vue';
import hzdw from './component/hzdw.vue';
import kpzq from './component/kpzq.vue';
import { findIndexInfo2 } from '../api/index';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    headers,
    sztd,
    jxfw,
    xyxs,
    hzdw,
    kpzq,
    pcBottom,
    Baywindow,
    flotRight
  },

  data() {
    // 这里存放数据
    return {
      img1: require('../assets/indexImg/11@2x.png'),
      img2: require('../assets/indexImg/22@2x.png'),
      img3: require('../assets/indexImg/33@2x.png'),
      img4: require('../assets/indexImg/44@2x.png'),
      img5: require('../assets/indexImg/55@2x.png'),
      img6: require('../assets/indexImg/66@2x.png'),
      img7: require('../assets/indexImg/77@2x.png'),
      img8: require('../assets/indexImg/88@2x.png'),
      img9: require('../assets/indexImg/99@2x.png'),
      img10: require('../assets/indexImg/1010@2x.png'),
      zyImg1: require('../assets/indexImg/znzz.png'),
      zyImg2: require('../assets/indexImg/rj.png'),
      zyImg3: require('../assets/indexImg/xxjs.png'),
      zyImg4: require('../assets/indexImg/jsj.png'),
      zyImg5: require('../assets/indexImg/qkljs.png'),
      className: '',
      localValue: '0702',
      jxjyCodeList: [], //继续教育分类
      numData: {}, //学习人数
      kstdCodeList: [],
      jyShow: false,
      jxjyHotCodeList: [], //专业技术人员继续教育
      tzggList: [], //政策法规
      hyzxList: [], //行业资讯
      zyjsList: [], //专业技术的课程数组
      zyjsEmpty: false,
      recommendEmpty: false,
      recommendCourseCodeList: [], //课程资源库推荐课程
      recommendCourseList: [],
      zypxHotCodeList: [], //职业培训的高薪之路
      codeExtendInfo: {}, //职业的数据
      courseTabIndex: 0,
      jxjyLiveCourseList: [], //继续教育的直播
      zypxLiveCourseList: [], //职业培训的直播
      zbList: [], //展示的直播
      liveIndex: 0,
      zbEmpty: false,
      bsnwIndex: 0,
      jxjyIndex: null,
      evaluateVoList: [],
      codeList:[],
      flotRightShow: false,
      index: '',
      list1: [], //推荐课程第一行
      list2: [], //推荐课程第二行
      bmShow: false,
      bmText: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goBm() {
      this.$router.push({
        path: '/lsitFs',
        query: {
          fCodeNo: '0702'
        }
      });
    },
    //获取首页数据
    getlist() {
      findIndexInfo2().then(res => {
        console.log(res, '0000');
        this.codeList = res.data.data.codeList;
        this.tzggList = res.data.data.tzggList;
        // this.hyzxList = res.data.data.hyzxList;
      });
    }, //搜索
    searClass(id) {
      if (this.className == '' && id !== 1) {
        return false;
      }
      this.localValue = {
        localValue: '',
        className: this.className
      };
      console.log(this.$route.path);
      this.$emit('updateParentValue', this.localValue); // 当输入框的值发生变化时，通过$emit事件告知父组件更新值
      if (this.$route.path !== '/lsitFs') {
        this.$router
          .push({
            path: '/classSearChList',
            query: {
              className: this.className
            }
          })
          .catch(err => {
            console.log('重复路由');
          });
      }
    },
        handleCode(codeId) {
      this.$router.push({
        path: '/lsitFs',
        query: {
           fCodeNo: '0702',
          codeNo: codeId
        }
      });
    },
        goCode() {
      this.$router.push({
        path: '/lsitFs',
        query: {
          fCodeNo: '0702'
        }
      });
    },
    //去资讯详情
    goFg(id, type, index) {
      console.log(id, type, index);
      this.$router.push({
        path: '/tzgg',
        query: {
          id: id,
          type: type,
          index: index
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.bmShow = localStorage.getItem('bmShow')
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    console.log(isMobile);
    if (isMobile) {
      window.location.href = 'http://m.ahzcj.com/';
    }
    this.getlist();
    // this.jxjyTuiJianClass();
    // this.toAllReadyBuy();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */

.tk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  .wtkBox {
    width: 440px;
    height: 193px;
    position: relative;
    padding: 26px 29px;
    .tkBac {
      position: absolute;
      top: 0;
      left: 0;
      width: 447px;
      height: 209px;
      z-index: -1;
    }
    .closeBox {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 14px;
      right: 15px;
      cursor: pointer;
    }

    .wxTtile {
      font-size: 18px;
      color: #333333;
    }
    .wx2 {
      margin-top: 14px;
      font-size: 16px;
      color: #333;
    }
    .wxBtn {
      margin-top: 23px;
      width: 120px;
      height: 40px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      box-shadow: 0px 3px 4px 0px rgba(21, 85, 202, 0.31);
      border-radius: 20px 20px 20px 20px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.btnShop {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  color: #4076f6;
  font-size: 16px;
  font-weight: 500;
  width: 200px;
  height: 48px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid;
  border-image: linear-gradient(97deg, rgba(149, 181, 255, 1), rgba(64, 147, 246, 1)) 1 1;
  img {
    width: 26px !important;
    height: 12px;
  }
}
.flexCenter {
  display: flex;
  justify-content: center;
}
.w {
  width: 1400px;
}
.bgc {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  .fsk {
    margin-top: 150px;
    width: 1048px;
    display: flex;
    justify-content: center;
    .txt1 {
      margin-top: 28px;
      margin-bottom: 24px;
      color: #fff;
      font-size: 18px;
      text-align: center;
    }
    .swInput {
      display: flex;
      .searCh {
        width: 696px;
        height: 52px;
        background: rgba(255, 255, 255, 0.3);
        color: #fff;
        border: 0 !important;
        border-radius: 6px 0px 0px 6px;
        font-size: 16px;
        padding-left: 24px;
      }
      input::placeholder {
        color: #fff !important; /* 设置颜色 */
      }
      .searBtn {
        width: 109px;
        height: 52px;
        background: linear-gradient(48deg, #6996ff 0%, #4076f6 100%);
        border-radius: 0px 6px 6px 0px;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        line-height: 52px;
        cursor: pointer;
      }
    }
    .listBox {
      position: relative;
      margin-top: 52px;
      width: 100%;
      // width: 1048px;
      height: 400px;
      display: flex;
      justify-content: space-between;
      background: rgba(2, 26, 61, 0.37);
      border-radius: 6px 6px 6px 6px;
      border: 1px solid;
      border-image: linear-gradient(155deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))
        1 1;
      padding: 30px 24px;
      backdrop-filter: blur(5px);
      .su {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1px;
        height: 90px;
        background: rgba(255, 255, 255, 0.2);
      }
      img {
        width: 20px;
        height: 20px;
      }
      .zjBox {
        width: 475px;
        font-size: 18px;
        .cpBox {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          height: 150px;
          .lBxp {
            margin-right: 70px;
            cursor: pointer;
            // width: 80px;
            padding: 0 10px;
            height: 30px;
            // background: rgba(255, 255, 255, 0);
            border-radius: 15px 15px 15px 15px;
            line-height: 30px;
            color: #ffffff;
            width: 260px;
            // height: 30px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 15px 15px 15px 15px;
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            // margin-right: 4px;
            margin-bottom: 4px;
            text-align: center;
          }
          .lBxp:hover {
            background: rgba(255, 255, 255, 0.5) !important;
            border-radius: 15px 15px 15px 15px !important;
          }
          .lBxp:nth-child(3n) {
            margin-right: 0 !important;
          }
        }
        .btnMore {
         // margin-top: 20px;
          width: 90px;
          height: 30px;
          border-radius: 15px 15px 15px 15px;
          border: 1px solid rgba(255, 255, 255, 0.6);
          cursor: pointer;
          text-align: center;
          line-height: 30px;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
        }
        .btnMore:hover {
          color: #fff !important;
          border: 0 !important;
          background: #24bd59;
          border-radius: 15px 15px 15px 15px;
        }
        .btnMoreHover:hover {
          color: #fff !important;
          border: 0 !important;
          background: #ff8833;
          border-radius: 15px 15px 15px 15px;
        }
      }
    }
    .jiti {
      padding: 0 24px;
      width: 1048px;
      justify-content: space-between;
      height: 60px;
      background: rgba(2, 26, 61, 0.5);
      border-radius: 8px 8px 8px 8px;
      border: 0.5px solid rgba(255, 255, 255, 0.1);
      margin-top: 20px;
      display: flex;
      align-items: center;
      .jintuText {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        width: 79px;
        line-height: 22px;
        height: 22px;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
        font-size: 16px;
        color: #ffffff;
      }
      .jinru_1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        margin-left: 15px;
      }
      .jinru_btn {
        width: 90px;
        height: 32px;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .listBox2 {
      margin-top: 30px;
      width: 1048px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .fwBox {
        width: 320px;
        height: 160px;
        background: rgba(2, 26, 61, 0.37);
        border-radius: 8px;
        border: 0.5px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
        backdrop-filter: blur(10px);

        .txt2 {
          display: flex;
          align-items: center;
          font-size: 16px;
          height: 22px;
          img {
            margin-top: 6px;
            width: 18px;
            height: 18px;
          }
        }
        .txt3 {
          height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          padding-left: 30px;
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          margin-top: 8px;
        }
        .txt4 {
          text-align: center;
          line-height: 48px;
          color: #fff;
          font-size: 14px;
          opacity: 0.8;
        }
        .bor {
          margin: 0 auto;
          width: 160px;
          height: 0.5px;
          background: rgba(255, 255, 255, 0.2);
        }
      }
      .fwBox:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }
}
.jyBox {
  position: relative;
  width: 100%;
  height: 334px;
  background: #ffffff;
  box-shadow: 0px 10px 60px 0px rgba(64, 114, 246, 0.2);
  padding-top: 136px;
  .showBox {
    position: absolute;
    top: -45px;
    left: 50%;
    transform: translateX(-50%);
    width: 1300px;
    height: 90px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .courseBox {
      width: 285px;
      height: 90px;
      background: rgba(255, 255, 255, 0.7);
      box-shadow: 0px 10px 40px 0px rgba(1, 40, 111, 0.12);
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #ffffff;
      cursor: pointer;
      backdrop-filter: blur(41.3px);
      .txt2 {
        display: flex;
        align-items: center;
        font-size: 16px;
        height: 22px;
        img {
          margin-top: 4px;
          width: 22px;
          height: 22px;
        }
      }
      .txt3 {
        padding-left: 30px;
        color: #666666;
        font-size: 14px;
        margin-top: 8px;
      }
      .txt4 {
        display: none;
        text-align: center;
        line-height: 48px;
        color: #fff;
        font-size: 14px;
      }
    }
    .courseBox:hover {
      border: 0 !important;
      width: 285px !important;
      height: 140px !important;
      background: linear-gradient(180deg, #6996ff 0%, #4076f6 100%) !important;
      box-shadow: 0px 10px 80px 0px rgba(1, 40, 111, 0.08) !important;
      border-radius: 8px 8px 8px 8px !important;
      border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5)) 1 1 !important;
      transition: height 0.5s ease; /* 定义多个过渡 */
      .borBox {
        border: 1px solid rgba(255, 255, 255, 0.15);
      }
      .txt2 {
        display: flex !important;
        align-items: center !important;
        font-size: 16px !important;
        height: 22px !important;
        color: #ffffff !important;
        img {
          margin-top: 4px;
          width: 22px;
          height: 22px;
        }
      }
      .txt3 {
        padding-left: 30px !important;
        color: #ffffff !important;
        font-size: 14px !important;
        margin-top: 8px !important;
      }
      .txt4 {
        display: block;
      }
    }
  }
  .head1 {
    font-weight: bold;
    font-size: 30px;
    color: #333333;
  }
  .head2 {
    margin: 8px 0 40px 0;
    font-size: 16px;
    color: #888888;
  }
  .iconBox {
    width: 1400px;
    padding: 0 39px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .ib {
      position: relative;
      width: 297px;
      cursor: pointer;
      .showImg {
        opacity: 0;
        position: absolute;
        width: 100px;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
      }
      .txt9 {
        font-size: 14px;
        text-align: center;
      }

      img {
        width: 44px;
        height: 44px;
      }
    }
    .ib1 {
      position: relative;
      width: 297px;
      cursor: pointer;
      .showImg {
        opacity: 0;
        position: absolute;
        width: 100px;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
      }
      .txt9 {
        font-size: 14px;
        text-align: center;
      }

      img {
        width: 44px;
        height: 44px;
      }
    }
    .ib1:hover {
      .txt9 {
        font-size: 14px;
        text-align: center;
      }
      .showImg {
        opacity: 1 !important;
        transition: all 0.3s linear;
      }
    }
  }
  .ib:hover {
    .txt9 {
      font-size: 14px;
      text-align: center;
    }
    .showImg {
      opacity: 1 !important;
      transition: all 0.3s linear;
    }
  }
}
.kc {
  position: relative;
  width: 100%;
  height: 747px;
  display: flex;
  justify-content: center;
  .bgcs {
    position: absolute;
    top: 0;
    width: 100%;
    height: 747px;
    z-index: -1;
  }
  .kcList {
    height: 236px;
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    width: 1400px;
    border-radius: 10px 10px 10px 10px;
    justify-content: space-between;

    .kcB {
      width: 49.5%;
      height: 236px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      cursor: pointer;
      padding: 30px;
      display: flex;
      box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;
      .fm {
        width: 220px;
        height: 170px;
      }
      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 100%;
        height: 100%;
      }
      .imgText {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }
      .bt {
        width: 380px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        color: #000;
        margin: 10px 0 12px 0;
        font-weight: bold;
      }
      .fl {
        display: flex;
        margin-bottom: 12px;
        .flx {
          padding: 0 12px;
          height: 23px;
          text-align: center;
          line-height: 23px;
          background: rgba(64, 118, 246, 0.1);
          border-radius: 2px 2px 2px 2px;
          color: #4076f6;
          font-size: 14px;
          margin-right: 12px;
        }
      }
      .studyTime {
        margin-bottom: 8px;
        font-size: 14px;
        color: #656e7e;
      }
      .btm {
        margin-top: 8px;
        display: flex;
        color: #ff6632;
        align-items: center;
        .skBtn {
          width: 90px;
          height: 36px;
          background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 36px;
          color: #fff;
          font-size: 12px;
          color: #fff;
          margin-left: 25px;
          box-shadow: 0px 5px 15px 0px rgba(64, 147, 246, 0.3);
        }
        .ljgm {
          margin-left: 12px;
          background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%) !important;
          box-shadow: 0px 5px 15px 0px rgba(196, 8, 12, 0.3) !important;
        }
      }
    }
    // .kcB:hover {
    //   .fm {
    //     /* 设置放大比例 */
    //     transform: scale(1.1) !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }
    //   .bt {
    //     color: #4076f6 !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }
    //   .flx {
    //     background: rgba(64, 118, 246, 0.1) !important;
    //     border-radius: 2px 2px 2px 2px !important;
    //     color: #4076f6 !important;
    //     /* 添加过渡效果 */
    //     transition: all 0.5s;
    //   }

    //   .skBtn {
    //     transition: opacity 1s ease; /* 添加过渡效果 */
    //     opacity: 1; /* 初始不透明度 */
    //   }
    // }
  }

  .newKcList {
    margin-top: 27px;
    width: 1400px;
    height: 330px;
    background: #ffffff;
    box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;
    border-radius: 10px 10px 10px 10px;
    padding: 30px 30px 0 30px;
    display: flex;
    justify-content: space-between;
    .newBox {
      width: 200px;
      cursor: pointer;
      .fmDiv {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 160px;
        overflow: hidden;
      }
      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
      }
      .imgText {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }
      img {
        width: 200px;
        height: 160px;
      }
      .ntext1 {
        width: 200px;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 10px 0 7px 0;
      }
      .nax {
        display: flex;
        justify-content: space-between;
        .na1 {
          width: 56px;
          height: 23px;
          background: #f6f6f6;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
          line-height: 23px;
          color: #666666;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .pric {
        margin-top: 10px;
        color: #ff6632;
        display: flex;
        font-size: 20px;
      }
    }
  }
}
.zxBox {
  position: relative;
  display: flex;
  margin-top: 29px;
  width: 1400px;
  height: 340px;
  background: #ffffff;
  box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16), inset 0px 20px 50px 0px #f0f3f9;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #ffffff;
  .xian {
    position: absolute;
    left: 50%;
    top: 65px;
    height: 120px;
    width: 1px;
    background: rgba(0, 0, 0, 0.1);
    transform: translateX(-50%);
  }
  .zbs {
    width: 50%;
    padding: 30px 30px 29px 30px;
    .headsw {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .z1 {
        color: #222222;
        font-weight: bold;
        font-size: 20px;
      }
      .z2 {
        display: flex;
        margin-top: 8px;
        color: #666666;
        font-size: 12px;
        cursor: pointer;
        img {
          margin-top: 2.5px;
          width: 12px;
          height: 12px;
        }
      }
    }
    .xwB {
      cursor: pointer;
      width: 100%;
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .xwContent {
        width: 400px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #222222;
        font-size: 16px;
      }
      .timer {
        color: #88888a;
        font-size: 14px;
      }
    }
    .xwB:hover {
      .xwContent {
        color: #4076f6 !important;
      }
      .timer {
        color: #4076f6 !important;
      }
    }
  }
}
.zyjs {
  width: 100%;
  height: 1080px;
  background: #ffffff;
  padding: 112px 0;
  display: flex;
  justify-content: center;
  .baners {
    width: 1400px;
    .js1 {
      font-weight: bold;
      font-size: 30px;
      color: #333333;
      text-align: center;
    }
    .js2 {
      font-size: 16px;
      color: #888888;
      text-align: center;
      margin-top: 8px;
      margin-bottom: 60px;
    }

    .navImgList {
      margin-top: 45px;
      display: flex;
      justify-content: space-between;
      .navBox {
        cursor: pointer;
        padding-top: 16px;
        width: 160px;
        height: 180px;
        margin-left: 88px;
        img {
          width: 160px;
          height: 87.33px;
        }
        .tx1 {
          margin-top: 16px;
        }
        .tx2 {
          display: none;
          font-size: 12px !important;
          text-align: center;
          margin-top: 8px;
          color: #fff;
        }
      }
      .navBox:nth-child(1) {
        margin-left: 0 !important;
      }
      .navBox:hover {
        background: linear-gradient(147deg, #6996ff 0%, #4093f6 100%);
        border-radius: 10px 10px 10px 10px;
        .tx1 {
          color: #fff !important;
        }
        .tx2 {
          display: block !important;
        }
      }
    }

    .navTent {
      display: flex;
      margin-top: 40px;
      height: 520px;

      .left_bgc {
        position: relative;
        width: 250px;
        height: 520px;
        .img1 {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
        .img2 {
          width: 196px;
          height: 196px;
          position: absolute;
          bottom: 16px;
          right: -15px;
          z-index: 1;
        }
        .z2 {
          position: relative;
          z-index: 2;
          font-size: 14px;
          color: #fff;
          padding: 0 20px 0 20px;
          cursor: pointer;
        }
      }

      .right_bgc {
        margin-left: 43px;
        width: 1107px;
        height: 520px;
        background: #f9fbff;
        border-radius: 20px 20px 20px 20px;
        overflow: hidden;
        .right_head {
          position: relative;
          width: 100%;
          height: 120px;
          background: #dbe5fd;
          padding: 31px 15px;
          display: flex;
          color: #333;
          .tb1 {
            font-size: 22px;
            font-weight: bold;
          }
          .tb2 {
            margin-top: 8px;
            font-size: 14px;
          }
          img {
            position: absolute;
            top: 0;
            right: 0;
          }
          .rh1 {
            display: flex;
            margin-left: 42px;
            margin-top: 12px;
            .l1 {
              width: 100px;
              height: 38px;
              background: #ffffff;
              border-radius: 4px 4px 4px 4px;
              margin-left: 20px;
              text-align: center;
              line-height: 38px;
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .rhi2 {
          padding: 30px 15px;
          .r1 {
            color: #4076f6;
            font-size: 22px;
            font-weight: bold;
          }
          .r2 {
            margin-top: 38px;
            display: flex;
            flex-wrap: wrap;
            .rbox:nth-child(2n) {
              margin-right: 0 !important;
            }
            .rbox {
              display: flex;
              margin-bottom: 40px;
              margin-right: 107px;
              .rb1 {
                width: 52px;
                height: 24px;
                background: rgba(64, 118, 246, 0.1);
                border-radius: 2px 2px 2px 2px;
                color: #4076f6;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
              }

              .rb2 {
                margin-left: 8px;
                .rb3 {
                  color: #333333;
                  font-size: 18px;
                  width: 425px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                .rb4 {
                  width: 425px;
                  margin-top: 8px;
                  color: #656e7e;
                  font-size: 14px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .r3 {
          cursor: pointer;
          width: 150px;
          height: 48px;
          background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
          box-shadow: 0px 5px 15px 0px rgba(196, 8, 12, 0.3);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          font-size: 18px;
          line-height: 48px;
          color: #fff;
        }
      }
    }
  }
}

.jyqj {
  position: relative;
  width: 100%;
  height: 1080px;
  padding: 196px 260px;
  display: flex;
  justify-content: center;
  .jyB1 {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
  }
  .tj1 {
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    color: #ffffff;
  }
  .tj2 {
    font-weight: 400;
    color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
    text-align: center;
    margin-top: 4px;
  }
  .jsmm {
    margin-top: 97px;
    display: flex;
    .left_mm {
      width: 443px;
      margin-top: 92px;
      .lt1 {
        font-weight: bold;
        font-size: 30px;
        color: #ffffff;
      }
      .lt2 {
        margin-top: 20px;
        width: 339px;
        font-size: 16px;
        color: #ffffff;
      }
      .lt3 {
        width: 300px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        .lt5 {
          display: flex;
          align-items: center;
          margin-right: 40px;
          margin-bottom: 20px;
          img {
            width: 20px;
            height: 20px;
            margin-top: 2px;
          }
          .lt6 {
            margin-left: 4px;
            color: #fff;
            font-size: 14px;
          }
        }
      }
      .lt4 {
        margin-top: 50px;
        display: flex;
        .btn2 {
          font-size: 16px;
          color: #ffffff;

          width: 150px;
          height: 48px;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 48px;
          cursor: pointer;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0)) 1 1;
        }
      }
    }
    .right_mm {
      width: 823px;
      display: flex;
      flex-wrap: wrap;
      margin-left: 120px;
      .rg1 {
        position: relative;
        margin-bottom: 20px;
        margin-right: 23px;
        width: 400px;
        height: 250px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 10px 10px 10px 10px;
        border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0)) 1 1;
        padding: 32px 18px 26px 23px;
        img {
          width: 154px;
          height: 154px;
          position: absolute;
          right: 18px;
          bottom: 26px;
        }
        .rm1 {
          font-weight: bold;
          font-size: 18px;
          color: #ffffff;
        }
        .rm2 {
          margin-top: 15px;
          width: 182px;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 16px;
        }
      }
      .rg1:nth-child(2n) {
        margin-right: 0 !important;
      }
    }
  }
}

.couserBox {
  position: relative;
  width: 100%;
  height: 1080px;
  display: flex;
  justify-content: center;
  padding-top: 94px;
  background: #f6f9fc;
  .c1 {
    position: relative;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    color: #333333;
    z-index: 2;
  }
  .c2 {
    position: relative;
    z-index: 2;
    margin-top: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #888888;
    text-align: center;
  }
  .courNav {
    margin-top: 63px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(51, 51, 51, 0.1);
    height: 40px;
    .courseName {
      cursor: pointer;
      margin-right: 47px;
      height: 40px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }
    .courseNameActive {
      color: #4076f6 !important;
      border-bottom: 2px solid #4076f6 !important;
    }
    .courseName:last-child {
      margin-right: 0 !important;
    }
    .z21 {
      position: absolute;
      right: 0;
      top: -10px;
      width: 80px !important;
      height: 28px !important;
      text-align: center !important;
      line-height: 28px !important;
      display: flex;
      margin-top: 8px;
      color: #4076f6;
      font-size: 14px;
      cursor: pointer;
      padding-left: 10px;
      .z2Bac {
        margin-top: 7.5px;
        width: 14px;
        height: 14px;
        background: url('../assets/indexImg/Frame.png');
      }
    }
    .z21:hover {
      border-radius: 14px 14px 14px 14px;
      text-align: center !important;
      line-height: 28px !important;
      color: #fff;
      background: linear-gradient(92deg, #6996ff 0%, #4076f6 100%);
      .z2Bac {
        background: url('../assets/indexImg/fff.png') !important;
      }
    }
  }

  .couserList {
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;

    .kcB {
      width: 220px;
      height: 300px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      cursor: pointer;
      overflow: hidden;
      .fm {
        width: 220px;
        height: 176px;
      }
      .fmImg {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 100%;
        height: 100%;
      }
      .bt {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        color: #000;
        margin: 10px 0 7px 0;
      }
      .fl {
        display: flex;
        .flx {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 56px;
          height: 23px;
          background: #f6f6f6;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
          line-height: 23px;
          color: #666666;
          font-size: 12px;
          margin-right: 8px;
        }
      }
      .btm {
        margin-top: 12px;
        display: flex;
        color: #ff6632;
        position: relative;
        .skBtn {
          position: absolute;
          top: 0;
          right: 0;
          opacity: 0;
          width: 54px;
          height: 28px;
          background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
          border-radius: 4px 4px 4px 4px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          font-size: 12px;
        }
      }
    }
    .kcbRes {
      position: relative;
      width: 220px;
      height: 300px;
      margin-right: 16px;
      margin-bottom: 30px;

      .kcB:hover {
        position: absolute !important;
        bottom: 0px !important;
        // left: -10px !important;
        width: 240px !important;
        height: 328px !important;
        background: #ffffff !important;
        border-radius: 8px 8px 8px 8px !important;
        cursor: pointer !important;
        transform: translate(-10px);
        /* 添加过渡效果 */
        transition: all 0.2s linear;
        box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.08);
        .fm {
          width: 240px !important;
          height: 192px !important;
          /* 添加过渡效果 */
          transition: all 0.2s linear;
        }
        .skBtn {
          opacity: 1;
          /* 添加过渡效果 */
          transition: all 0.2s;
        }
        .bt {
          color: #4076f6 !important;
          transition: all 0.2s;
        }
        .flx {
          background: rgba(64, 118, 246, 0.1) !important;
          color: #4076f6 !important;
          transition: all 0.2s;
        }
      }
    }
    .kcbRes:nth-child(6n) {
      margin-right: 0 !important;
    }
  }

  .swthc {
    width: 200px;
    height: 44px;
    background: #f6f9fc;
    box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.06);
    border-radius: 25px 25px 25px 25px;
    border: 1px solid #f1f1f1;
    display: flex;
    margin: 60px auto 30px auto;

    .nav1 {
      width: 100px;
      height: 44px;
      background: #ffffff;
      border-radius: 25px 25px 25px 25px;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      cursor: pointer;
    }
    .nav2 {
      width: 100px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      cursor: pointer;
      color: #666666;
    }
  }

  .zblist {
    display: flex;
    flex-wrap: wrap;
    .abBox {
      width: 335px;
      height: 302px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #f1f1f1;
      margin-right: 20px;
      margin-bottom: 30px;
      .ab1 {
        width: 335px;
        height: 160px;
      }
      .ab1Img {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 335px;
        height: 160px;
      }
      .ab1Text {
        font-size: 15px;
        font-family: kaiti;
        text-align: center;
        padding: 0px 10px;
        font-weight: bold;
        color: rgb(53, 95, 217);
        position: relative;
        z-index: 2;
      }
      .ab2 {
        padding: 16px 20px 0 20px;
        .ab3 {
          width: 290px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
        .ab4 {
          margin-top: 8px;
          width: 295px;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          padding-bottom: 15px;
          border-bottom: 1px solid #f1f1f1;
        }
      }

      .teach {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 55px;
        width: 100%;
        padding: 0 20px;
        .tx {
          display: flex;
          align-items: center;
          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }
          .txname {
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-left: 8px;
          }
        }

        .yyBtn {
          cursor: pointer;
          width: 90px;
          height: 36px;
          background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
          border-radius: 18px 18px 18px 18px;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    .abBox:nth-child(4n) {
      margin-right: 0 !important;
    }
  }

  .gyBgc {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .navbsnw {
    position: relative;
    z-index: 2;
    margin-top: 50px;
    display: flex;
    .bsnwBox {
      width: 120px;
      height: 44px;
      background: #ffffff;
      border-radius: 24px 24px 24px 24px;
      text-align: center;
      line-height: 44px;
      cursor: pointer;
      font-size: 16px;
      color: #333333;
      margin-right: 16px;
    }
    .bsnwBoxActive {
      background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%) !important;
      color: #fff !important;
      opacity: 0.8 !important;
    }
  }

  .navBanner {
    margin-top: 70px;
    display: flex;
    position: relative;
    z-index: 2;
    .navLeft {
      width: 850px;
      height: 520px;
      background: rgba(50, 90, 210, 0.08);
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #dbe5fd;
      padding: 24px 20px;
      margin-top: 50px;
      .navHead {
        width: 790px;
        height: 110px;
        border-radius: 10px 10px 10px 10px;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        padding: 29px 0;
        text-align: center;
        position: relative;
      }
      .navText {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        .n1 {
          width: 250px;
          height: 170px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          margin-right: 20px;
          padding: 26px 20px;
          .n2 {
            color: #4076f6;
            font-size: 14px;
          }
          .n3 {
            font-weight: 400;
            font-size: 14px;
            color: #656e7e;
          }
        }
        .n4 {
          margin-top: 20px;
          width: 385px;
          height: 150px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          margin-right: 20px;
          padding: 26px 20px;
          .n2 {
            color: #4076f6;
            font-size: 14px;
          }
          .n3 {
            font-weight: 400;
            font-size: 14px;
            color: #656e7e;
          }
        }
      }
    }

    .navRight {
      margin-left: 90px;
      img {
        width: 520px;
      }
    }

    .fzjl {
      margin-top: 50px;
      width: 1464px;
    }
  }
}
.bottom11 {
  margin-top: 90px;
  width: 100%;
  flex-direction: column;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  .text_1 {
    cursor: pointer;
  }
  .text_3 {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.xwList {
  text-align: center;
  line-height: 40px;
  width: 150px;
  height: 40px;
  // margin-top: 20px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  cursor: pointer;
  font-size: 16px;
  color: #ffffff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  .xwText {
    width: 368px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.xwList1 {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  .xwText {
    width: 368px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
